import { render, staticRenderFns } from "./wechatView.vue?vue&type=template&id=93bf5346&scoped=true"
import script from "./wechatView.vue?vue&type=script&lang=js"
export * from "./wechatView.vue?vue&type=script&lang=js"
import style0 from "./wechatView.vue?vue&type=style&index=0&id=93bf5346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bf5346",
  null
  
)

export default component.exports